import React from 'react'
import merge from 'lodash/merge'
import { TextAreaProps } from './TextArea.types'
import InputWrapper from '../InputWrapper/InputWrapper'
import useInput from '../useInput'

const TextArea: React.FC<TextAreaProps> = (props) => {
    const { placeholder, minLength, style = {}, height } = props
    const context = useInput(props, 'string')
    const { onBlur, onFocus, onChange, value, isDisabled } = context

    const handleChange = (e) => {
        const val = e.target.value
        if (isDisabled) {
            return
        }

        if (val !== value) {
            onChange(val)
        }
    }

    const _style = {
        height,
    }

    return (
        <InputWrapper {...context}>
            <textarea
                style={merge(style, _style)}
                onFocus={onFocus}
                onBlur={onBlur}
                placeholder={placeholder || ''}
                disabled={isDisabled}
                data-testid='TextArea'
                className={'r-textarea r-input-base'}
                value={value}
                onChange={handleChange}
            />
        </InputWrapper>
    )
}

export default TextArea
